import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import * as reducers from 'Store/reducers';

import Form from 'Components/Form';
import DeactivateUserButton from 'Containers/DeactivateUserButton';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class AccountSettings extends React.Component {
  render() {
    const { user, activeUser, school, formStyle } = this.props;
    const isActiveUser = user.id === activeUser.id;
    if (!user || !school) return null;
    const { family_name, given_name, auth_info, roleStringId } = user;
    const formType = user.isEducator ? 'editTeacher' : 'editStudent';
    const roleString = <ConnectedFormattedMessage id={roleStringId} />;
    return (
      <div className="AccountSettings">
        <Form
          type={formType}
          id={formType}
          initialFieldSettings={{
            username: { value: auth_info.username },
            family_name: { value: family_name },
            given_name: { value: given_name },
            role: { value: roleString },
            schoolName: { value: school.name },
          }}
          formStyle={formStyle}
          messagePosition="content-frame"
          submitArgs={{ id: user.id }}
          submitButtonType={formStyle === 'editUser' ? 'secondary' : 'primary'}
          hideOptionalFlags={true}
        />
        {!isActiveUser && activeUser.isAdmin ? (
          <DeactivateUserButton user={user} />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    school: reducers.getSchool(state, reducers.getActiveSchoolId(state)),
    activeUser: reducers.getActiveUser(state),
  };
};

AccountSettings.propTypes = {
  formStyle: PropTypes.string,
  user: PropTypes.object.isRequired,
  activeUser: PropTypes.object,
  school: PropTypes.object,
};

AccountSettings.defaultProps = {
  formStyle: 'accountBasics',
};

export default connect(mapStateToProps, false)(AccountSettings);
